import moment from 'moment';
import { createSelector } from 'reselect';

export const getGames = (state) => state.games

export const getOrderedGames = createSelector(
    [ getGames ],
    ( games ) => {
        let orderedGames = games.ids.sort(function(a, b){
            let dateA = moment(games.byId[a].gameStartTime),
                dateB = moment(games.byId[b].gameStartTime);

            // Compare the dates
            if(dateA.isBefore(dateB)) return -1;
            if(dateA.isAfter(dateB)) return 1;
            return 0;
        });
        return orderedGames.map((id) => {
            return games.byId[id];
        });
    }
)

export const getAllGames = createSelector(
    [getGames],
    (games) => {
        let allGames = games.ids.map((id) => {
            return games.byId[id];
        });
        return allGames;
    }
)


// WEBPACK FOOTER //
// ./src/selectors/game.selector.js